export default "__VITE_ASSET__DqygKPyp__"